<template>
    <div class="product__item product__item--accordion" :index="index" ref="row">
        <input :id="'domain_' + index" type="radio" name="domain" :checked="checked" @change="scrollToElement" />

        <div class="layout">
            <label :for="'domain_' + index" class="product__item-header | u-cursor-pointer">
                <div class="layout__item u-2/3-desk">
                    <span>
                        {{ domain.domain }}
                    </span>
                </div>

                <div class="layout__item u-1/3-desk">
                    <div class="u-text-right">
                        <vps-switcher v-if="canAccessVps" v-on:switchedType="changeType($event)" />
                    </div>
                </div>
            </label>
        </div>

        <div class="product__item-body">
            <hosting-plans :domain="domain" :selectedType="selectedType" />
        </div>
    </div>
</template>

<script>
import HostingPlans from './HostingPlans.vue';
import accordionMixin from '../../mixins/accordion';
import VpsSwitcher from '../vps/VpsSwitcher.vue';
import { mapGetters } from 'vuex';

export default {
    props: {
        domain: Object,
        index: Number
    },
    mixins: [accordionMixin],
    components: {
        VpsSwitcher,
        HostingPlans
    },
    computed: {
        ...mapGetters({
            domains: 'order/domains'
        }),
        /**
         * Check if VPS functionality is enabled.
         *
         * @return {boolean}
         */
        canAccessVps() {
            return process.env.VUE_APP_VPS_ENABLED === 'true';
        }
    },
    data() {
        return {
            selectedType: 'webhosting'
        };
    },
    methods: {
        changeType(type) {
            this.selectedType = type;
        }
    }
};
</script>
